import React from 'react';
import { Layout, Tag, Modal, Tooltip, message } from 'antd';
import NHTree from '../NHTree';
import SelectorContent from './content';
import NHFetch from '../../../utils/NHFetch';
import { createUuid } from '../../../utils/NHCore';
const { Sider, Content } = Layout;
const pathUrl = "api";

class NHSelector extends React.Component {
    //设置可以传递参数的默认值
    static defaultProps = {
        title: '选择器标题',
        onOk: (resultObj) => {
            /* 
            resultObj = {selectedKeys:this.state.selectedRowKeys,
                  selectedNames:this.state.selectedRowNames,
                  selectedObjs:this.state.selectedRows};
            说明：selectedKeys选中的所有值集合
                  selectedNames选中的所有Text集合
                  selectedObjs选中的所有数据集合
             */
        },
        width: '1000px',
        height: '400px',
        leftTree: true,
        treeCheckable: false,
        treeSearch: false,
        maskClosable: false,//点击蒙层是否允许关闭,默认值为true
        closable: true,//是否显示右上角的关闭,默认值为true
        sign: 'zhxg_js_selector',
        isSingle: false,
        // key:'wydjkyl'//当想要重新加载一个新的选择器，可以使用
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            visibleFlag: false,//是否可以显示
            okText: '确定',
            cancelText: '取消',
            selectedRows: [],
            selectedRowKeys: [],
            selectedRowNames: [],
            treeParams: {},
            initParams: {},
            /*  gridColumns:[
                   {
                         title: '工号',
                         key: 'gh',
                         width:'100px',
                         dataIndex: 'GH'
                   }, {
                         title: '姓名',
                         key: 'xm',
                         width:'150px',
                         dataIndex: 'XM'
                   }, {
                         title: '性别',
                         key: 'xb',
                         width:'80px',
                         dataIndex: 'XB'
                   }, {
                         title: '部门',
                         key: 'bmmc',
                         // width:'100px',
                         dataIndex: 'BMMC'
                   }
             ],//需要查询的条件
             treeParamsText:'bmlbm,bmid',//左侧树的查询字段
             treeSign:'zhxg_all_dept',//左侧树标志
             searchParamsPro:[{key:'gh',name:'工号'} ,{key:'xm',name:'姓名'}],//grid的搜索条件
             gridSign:'zhxg_xgdw_jsjbxx_querypage',//表格标志
             gridRowKey:'GH',//表格的rowKey
             gridNameColumn:'XM',//selectedRowNames所返回的数据
              */
        }
    }
    componentWillMount() {
        this.loadSelectorMsg();
    }
    loadSelectorMsg = () => {
        let sign = this.props.sign;
        NHFetch('/proData/querySelectorMsg', 'get', `sign=${sign}`).then(res => {
            if (res && res.data) {
                let { description, treeSign, treeParamsText, gridSign, gridRowKey, gridNameColumn, searchParamsPro } = res.data;
                let gridColumns = (res.data.gridColumns instanceof Array) ? res.data.gridColumns : [res.data.gridColumns];
                for (let map of gridColumns) {
                    if (map.tigColumn) {
                        map['render'] = (text, record, index) => {
                            let uuid = createUuid();
                            return <Tooltip key={uuid} title={record[map.tigColumn]}>{text}</Tooltip>
                        }
                    }
                }
                this.setState({
                    visibleFlag: true, description: description, treeSign: treeSign, treeParamsText: treeParamsText, gridSign: gridSign,
                    gridRowKey: gridRowKey, gridNameColumn: gridNameColumn, gridColumns: gridColumns, searchParamsPro: searchParamsPro
                });
            }
        });
    }
    show = (params, treePid) => {
        if (!this.state.visibleFlag) {
            message.error("获取选择器出错，请与管理员联系！");
            return;
        }
        let selectorResult = this.props.selectorResult;
        if (!selectorResult) {
            let selectedRows = [];
            let selectedRowKeys = [];
            let selectedRowNames = [];
            selectorResult = { selectedRows: [], selectedRowKeys: [], selectedRowNames: [] };
        }
        this.setState({ visible: true, ...selectorResult, isSingle: this.props.isSingle, initParams: params ? params : {}, treePid: treePid ? treePid : undefined }, () => {
            if (this.nhTree) {
                this.nhTree.onRest();
            }
            this.setState({
                treeParams: {}
            }, () => {
                if (this.selectorContent) {
                    this.selectorContent.resetState();
                    this.selectorContent.filterTableData();
                }
            })
        });
    }
    close = () => {
        this.setState({ visible: false });
    }
    handleClose = (key) => {
        let gridRowKey = this.state.gridRowKey;

        let selectedRows = this.state.selectedRows;
        let selectedRowKeys = this.state.selectedRowKeys;

        selectedRows = selectedRows.filter(row => row[gridRowKey] !== key);
        selectedRowKeys = selectedRowKeys.filter(value => value !== key);
        let selectedRowNames = selectedRows.map((item) => {
            return item[this.state.gridNameColumn];
        })

        this.setState({ selectedRowKeys: selectedRowKeys, selectedRows: selectedRows, selectedRowNames: selectedRowNames });
    }
    buildRightTig = (selectedRows) => selectedRows.map((item) => {
        let key = this.state.gridRowKey;
        let name = this.state.gridNameColumn;
        let xbm = item.XBM;
        let xb = item.XB;
        let color = '';
        if (xbm == '1' || xb == '男') {
            color = 'blue';
        } else if (xbm == '2' || xb == '女') {
            color = 'red';
        }
        let title = item[name];
        return <Tag style={{ marginTop: '3px' }} key={item[key]} color={color} closable={true} onClose={() => this.handleClose(item[key])}>
            {title.length < 5 ? title : <Tooltip title={title}>{`${title.substring(0, 4)}...`}</Tooltip>}
        </Tag>
    })
    changeRowsFunc = (changeRows) => {
        let selectedRowKeys = this.state.selectedRowKeys;
        let selectedRows = this.state.selectedRows;
        let selectedRowNames = this.state.selectedRowNames;
        for (let obj of changeRows) {
            let selectKey = obj[this.state.gridRowKey];
            if (selectedRowKeys.indexOf(selectKey) == -1) {
                selectedRowKeys.push(selectKey);
                selectedRows.push(obj);
                selectedRowNames.push(obj[this.state.gridNameColumn]);
            }
        }
        this.setState({ selectedRowKeys: selectedRowKeys, selectedRows: selectedRows, selectedRowNames: selectedRowNames });

    }
    selectRowsFunc = (record, selected, selectedRows) => {
        if (selected) {
            let isSingle = this.props.isSingle;
            if (isSingle) {
                this.setState({
                    selectedRowKeys: [record[this.state.gridRowKey]],
                    selectedRows: [record],
                    selectedRowNames: [record[this.state.gridNameColumn]]
                });
            } else {
                let selectedRowKeys = this.state.selectedRowKeys;
                let selectedRows = this.state.selectedRows;
                let selectedRowNames = this.state.selectedRowNames;

                selectedRowKeys.push(record[this.state.gridRowKey]);
                selectedRows.push(record);
                selectedRowNames.push(record[this.state.gridNameColumn]);
                this.setState({
                    selectedRowKeys: selectedRowKeys, selectedRows: selectedRows,
                    selectedRowNames: selectedRowNames
                });
            }
        } else {
            this.handleClose(record[this.state.gridRowKey]);
        }
    }
    selectAllFunc = (selected, selectedRows, changeRows) => {
        if (selected) {
            this.changeRowsFunc(changeRows);
        } else {
            let selectedRowKeys = this.state.selectedRowKeys;
            let selectedRows = this.state.selectedRows;
            let gridRowKey = this.state.gridRowKey;

            for (let obj of changeRows) {
                let key = obj[gridRowKey];
                selectedRows = selectedRows.filter(row => row[gridRowKey] !== key);
                selectedRowKeys = selectedRowKeys.filter(value => value !== key);
            }

            let selectedRowNames = selectedRows.map((item) => {
                return item[this.state.gridNameColumn];
            })
            this.setState({ selectedRowKeys: selectedRowKeys, selectedRows: selectedRows, selectedRowNames: selectedRowNames });
        }
    }
    okHandle = () => {
        let onOk = this.props.onOk;
        if (onOk) {
            let resultObj = {
                selectedKeys: this.state.selectedRowKeys,
                selectedNames: this.state.selectedRowNames,
                selectedObjs: this.state.selectedRows
            };
            onOk(resultObj);
        }
        this.close();
    }
    render() {
        const selectTags = this.buildRightTig(this.state.selectedRows);
        let commentHeight = this.props.height ? this.props.height : '400px';
        let commentHeightNum = Number.parseInt(commentHeight.substring(0, commentHeight.length - 2));
        return (
            <Modal /* key={this.props.key} */
                title={this.props.title}
                onOk={this.okHandle}
                onCancel={this.close}
                visible={this.state.visible}
                okText={this.state.okText}
                cancelText={this.state.cancelText}
                maskClosable={this.props.maskClosable}
                closable={this.props.closable}
                width={this.props.width ? this.props.width : '800px'}
            >
                <Layout>
                    {this.props.leftTree &&
                        <Sider width={177} style={{ height: commentHeight, overflow: 'hidden', backgroundColor: '#fff' }}>
                            <NHTree ref={(modal) => { this.nhTree = modal }} sign={this.state.treeSign}
                                search={this.props.treeSearch}
                                width={160} pid={this.state.treePid}
                                height={commentHeightNum}
                                checkable={this.props.treeCheckable}
                                selectTreeNode={this.props.treeCheckable ? undefined : (selectKey, obj) => {
                                    let treeParams = {};
                                    let treeParamsText = this.state.treeParamsText;
                                    let treeParamsArr = treeParamsText.split(',');
                                    for (let value of treeParamsArr) {
                                        treeParams[value] = selectKey;
                                    }
                                    this.setState({
                                        treeParams: treeParams
                                    }, () => {
                                        this.selectorContent.filterTableData();
                                    });
                                }}
                                checkedTreeNode={this.props.treeCheckable ? (selectKey, obj) => {
                                    let treeParams = {};
                                    let treeParamsText = this.state.treeParamsText;
                                    let treeParamsArr = treeParamsText.split(',');
                                    for (let value of treeParamsArr) {
                                        treeParams[value] = selectKey;
                                    }
                                    this.setState({
                                        treeParams: treeParams
                                    }, () => {
                                        this.selectorContent.filterTableData();
                                    });
                                } : undefined}
                            />
                        </Sider>
                    }
                    <Content>
                        <SelectorContent ref={(modal) => { this.selectorContent = modal }}
                            commentHeight={commentHeightNum} treeSearchParams={this.state.treeParams}
                            changeRowsFunc={this.changeRowsFunc} sign={this.state.gridSign}
                            selectRowsFunc={this.selectRowsFunc} selectAllFunc={this.selectAllFunc}
                            searchParamsPro={this.state.searchParamsPro} gridColumns={this.state.gridColumns}
                            gridRowKey={this.state.gridRowKey} isSingle={this.state.isSingle}
                            initParams={this.state.initParams} defaultSelectKeys={this.state.selectedRowKeys} />
                    </Content>
                    <Sider width={108} style={{ height: commentHeight, overflow: 'hide', backgroundColor: '#fff', paddingLeft: '12px' }}>
                        <div style={{ height: commentHeightNum - 24, overflow: 'auto' }}>
                            {selectTags}
                        </div>
                        <div style={{ height: '24px', textAlign: 'right', margin: '5px 12px' }}>
                            总计：{this.state.selectedRowKeys.length}人
                                    </div>
                    </Sider>
                </Layout>
            </Modal>
        );
    }
}

export default NHSelector;


// WEBPACK FOOTER //
// ./components/common/NHSelector/index.js